import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export async function generatePartidasFromText({ description, tipo, catalog }) {
  const { data } = await axios.post(`${API}/ai/generate-partidas`, {
    description,
    tipo: tipo || "completo",
    catalog: catalog || [],
  });
  return data;
}

export async function reviewBudgetWithAI({ partidas, description }) {
  const { data } = await axios.post(`${API}/ai/review-budget`, {
    partidas,
    description: description || "",
  });
  return data;
}

export async function healthCheck() {
  const { data } = await axios.get(`${API}/health`);
  return data;
}
